export { default } from './TTPSlider';
